export default "__VITE_ASSET__DIPl1dVB__"